var _path, _g, _circle, _g2, _circle2, _g3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaturn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 668,
    viewBox: "0 0 668 668",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape Copy 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2854 53.2834C53.3982 53.1623 53.5132 53.0431 53.6303 52.926C82.3349 24.2214 231.288 126.635 386.326 281.673C541.364 436.711 643.778 585.664 615.073 614.369C614.956 614.486 614.837 614.601 614.716 614.714L569.192 569.19C569.314 569.078 569.434 568.963 569.551 568.846C593.6 544.797 507.794 419.998 377.898 290.101C248.001 160.205 123.202 74.3986 99.1527 98.4483C99.0356 98.5655 98.921 98.6851 98.8091 98.807L53.2854 53.2834ZM109.848 109.846C132.734 86.9597 251.485 168.605 375.086 292.206C498.687 415.807 580.332 534.558 557.446 557.444L540.303 540.301C540.426 540.19 540.545 540.075 540.663 539.958C561.803 518.818 486.572 409.311 372.63 295.369C258.688 181.427 149.181 106.196 128.041 127.336C127.924 127.454 127.809 127.574 127.698 127.696L109.848 109.846Z",
    fill: "#B87D43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 334,
    cy: 318,
    r: 208,
    fill: "#FCCB6B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_7442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 110,
    width: 416,
    height: 416
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "path-1_2",
    cx: 334,
    cy: 318,
    r: 208,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_7442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.369 518.472C535.683 513.785 528.085 513.785 523.399 518.472C518.712 523.158 518.712 530.756 523.399 535.442L633.707 645.751C638.394 650.437 645.992 650.437 650.678 645.751C655.364 641.065 655.364 633.467 650.678 628.78L540.369 518.472ZM384.806 362.908C380.119 358.222 372.521 358.222 367.835 362.908C363.149 367.594 363.149 375.192 367.835 379.879L422.989 435.033L422.982 435.04C427.319 439.748 427.204 447.082 422.636 451.65C418.068 456.218 410.733 456.333 406.026 451.996L406.019 452.004L292.882 338.867C288.195 334.18 280.598 334.18 275.911 338.867C271.225 343.553 271.225 351.151 275.911 355.837L457.638 537.564C462.324 542.25 469.922 542.25 474.608 537.564C479.295 532.877 479.295 525.279 474.608 520.593L439.96 485.945C435.274 481.258 435.274 473.66 439.96 468.974C444.646 464.288 452.244 464.288 456.931 468.974L478.144 490.187C482.83 494.874 490.428 494.874 495.114 490.187C499.801 485.501 499.801 477.903 495.114 473.217L384.806 362.908ZM461.88 575.747C457.194 571.061 449.596 571.061 444.91 575.747C440.223 580.434 440.223 588.032 444.91 592.718L496.529 644.337C501.215 649.023 508.813 649.023 513.499 644.337C518.185 639.65 518.185 632.052 513.499 627.366L461.88 575.747ZM258.941 372.808C254.254 368.121 246.656 368.121 241.97 372.808C237.284 377.494 237.284 385.092 241.97 389.778L293.589 441.397C298.275 446.083 305.873 446.083 310.559 441.397C315.246 436.711 315.246 429.113 310.559 424.426L258.941 372.808ZM63.7792 194.617C68.4655 189.93 76.0634 189.93 80.7497 194.617L198.129 311.996C202.816 316.683 202.816 324.281 198.129 328.967C193.443 333.653 185.845 333.653 181.159 328.967L63.7792 211.587C59.0929 206.901 59.0929 199.303 63.7792 194.617ZM257.526 269.57C252.84 264.884 245.242 264.884 240.556 269.57C235.87 274.256 235.87 281.854 240.556 286.541L246.92 292.905C251.606 297.591 251.606 305.189 246.92 309.875C242.234 314.561 234.636 314.561 229.949 309.875L48.2228 128.149C43.5365 123.462 43.5365 115.864 48.2228 111.178C52.9091 106.492 60.5071 106.492 65.1934 111.178L206.615 252.599L206.622 252.592C211.329 256.929 218.664 256.814 223.232 252.246C227.8 247.678 227.915 240.344 223.578 235.636L223.585 235.629L206.615 218.658C201.928 213.972 201.928 206.374 206.615 201.688C211.301 197.002 218.899 197.001 223.585 201.688L333.894 311.996C338.58 316.683 338.58 324.281 333.894 328.967C329.208 333.653 321.61 333.653 316.923 328.967L257.526 269.57ZM55.2939 50.3669C59.9802 45.6807 67.5782 45.6806 72.2645 50.3669L182.573 160.676C187.259 165.362 187.259 172.96 182.573 177.646C177.887 182.332 170.289 182.332 165.603 177.646L55.2939 67.3375C50.6076 62.6512 50.6076 55.0532 55.2939 50.3669Z",
    fill: "#ECB55A"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_7442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 110,
    width: 416,
    height: 416
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "path-1_3",
    cx: 334,
    cy: 318,
    r: 208,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_7442)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    opacity: 0.0775757,
    x: 334,
    y: 110,
    width: 209.089,
    height: 416,
    fill: "black"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2842 53.2846C53.1631 53.3974 53.0439 53.5124 52.9268 53.6295C24.2223 82.334 126.636 231.287 281.674 386.325C436.712 541.363 585.665 643.777 614.37 615.072C614.487 614.955 614.602 614.836 614.714 614.715L569.191 569.191C569.079 569.313 568.964 569.433 568.847 569.55C544.797 593.6 419.999 507.794 290.102 377.897C160.205 248 74.3994 123.202 98.4492 99.1519C98.5663 99.0347 98.6859 98.9202 98.8078 98.8082L53.2842 53.2846ZM109.846 109.847C86.9605 132.733 168.606 251.484 292.207 375.085C415.808 498.686 534.559 580.332 557.445 557.445L540.302 540.302C540.19 540.425 540.076 540.545 539.959 540.662C518.819 561.802 409.312 486.571 295.37 372.629C181.428 258.687 106.197 149.18 127.337 128.04C127.454 127.923 127.574 127.809 127.697 127.697L109.846 109.847Z",
    fill: "#B87D43"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturn);
export default __webpack_public_path__ + "static/media/Saturn.9cfe161f4a7eebd2c32799fd6bb874a3.svg";
export { ForwardRef as ReactComponent };